import { api } from "./restUtil";
import { LocalStorageKeys } from "utils/storage";

export type Language = {
  code: string;
  english_name: string;
  native_name: string;
};

type AWSConfig = {
  bucket: string;
  cognito: {
    aws_cognito_identity_id: string;
    aws_cognito_token: string;
    aws_cognito_identity_pool_id: string;
  };
  region: string;
};

type CachedLanguages = {
  time: number;
  languages: Language[];
};

const LANGUAGES_CACHE_TTL = 5 * 60 * 1000;

export function getAWSConfig(): Promise<AWSConfig> {
  return api.get<AWSConfig>("/configuration/aws");
}

export async function getLanguages(): Promise<Language[]> {
  const raw = localStorage.getItem(LocalStorageKeys.nativeLanguages);
  const cached: CachedLanguages | null = raw ? JSON.parse(raw) : null;
  if (cached && new Date().getTime() - cached.time <= LANGUAGES_CACHE_TTL) {
    return cached.languages;
  }
  const languages = await api.get<Language[]>("/configuration/languages");
  localStorage.setItem(
    LocalStorageKeys.nativeLanguages,
    JSON.stringify({ time: new Date().getTime(), languages })
  );
  return languages;
}

export function getOnboardingLanguages(): Promise<Language[]> {
  // Public endpoint
  return api.get("/configuration/languages", undefined, { credentials: "omit" });
}
